export default __webpack_public_path__ + "static/media/gauda_vakum.27417865.jpg";